// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'D:/gitee/xy-home/xy-home-web/src/models/common';
import model_2 from 'D:/gitee/xy-home/xy-home-web/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'common', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
